import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { BillingPlanMapping } from '/@/modules/billing/models/BillingPlanMapping';

export class BillingPlanMappingService extends BaseEntityService {
  getRoute() {
    return Route.BILLINGS_PLANS;
  }

  getModel() {
    return BillingPlanMapping;
  }
}

export default new BillingPlanMappingService();
